<template>
  <div class="basic_wrap choose_wrap">
    <div class="red_top_bg">
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/'+lang+'.png')">
      </div>
      <div class="big_tit">
        {{ $t('sky.xuan') }}
      </div>
      <div class="top_right" />
    </div>
		
		
    <van-swipe
      class="banner-swipe"
      :autoplay="3000"
      lazy-render
    >
      <van-swipe-item
        v-for="(item, index) in banner"
        :key="index"
      >
        <img
          :src="item[lang]"
          width="100%"
          style="width: 100%;"
        >
      </van-swipe-item>
    </van-swipe>
		
    <div
      class="head-tabs vip-tabs"
      aria-label="VIP"
    >
      <span
        class="tab-item "
        :class="cur==0?'active':''"
        @click="cur=0;resetGirls();"
      >VIP</span>
    </div>
    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      />
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="100"
        style="padding-bottom: 60px;"
        :loading-text="$t('pro2.loading')"
        @load="loadGirls"
      >
        <div
          v-if="girls.length"
          class="pblBox"
        >
          <div
            v-for="(item, index) in girls"
            :key="index"
            style="width: calc(50% - 5px);"
            @click="$router.push('/vprofile/'+item.id)"
          >
            <div class="releaseItem">
              <div class="imgBox">
                <div
                  class="van-image"
                  style="width: 100%; height: 100%;"
                >
                  <img
                    :src="item.pic"
                    class="van-image__img"
                  >
                </div>
                <span><i>{{ $t('sky.gaoduan') }}</i></span>
                <div class="infoBox">
                  <i
                    class="van-icon van-icon-location"
                    style="font-size: 14px;"
                  /><span
                    style="font-size: 12px; margin: 0px 0px 0px 2px;"
                  />
                  <div class="wantyuebtn">
                    {{ $t('sky.yue') }}
                  </div>
                </div>
              </div>
              <div
                class="tagBox"
                style="color: rgb(102, 102, 102);"
              >
                <span
                  v-if="item.keys[0]"
                  class="van-tag  van-tag--primary"
                >{{ item.keys[0] }}</span>
                <span
                  v-if="item.keys[1]"
                  class="van-tag  van-tag--success"
                >{{ item.keys[1] }}</span>
                <span
                  v-if="item.keys[2]"
                  class="van-tag  van-tag--danger"
                >{{ item.keys[2] }}</span>
                <span
                  v-if="item.keys[3]"
                  class="van-tag  van-tag--warning"
                >{{ item.keys[3] }}</span>
              </div>
              <div class="di">
                <div>
                  <span style="display: inline-block; margin-right: 2px; width: 12px; height: 12px; border-radius: 50%; background: rgb(239, 186, 143);" />
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <i
                    class="van-icon van-icon-like"
                    style="color: rgb(220, 99, 161);"
                  /><span>{{ item.zan }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
	
	import Vue from "vue";
	import {
		Swipe,
		SwipeItem,
		Empty,List,Card,ShareSheet 
	} from "vant";
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Choose",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				page:1,
				girls:[],
				banner:null,
				cur:0,
				area:null,
				arealist:null,
				islogin: false,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
				requestLock: false,
			};
		},
		created() {
			this.$parent.footer("girl",true);
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
			}
			this.getBanner();
		},
		methods: {
			getBanner() {
				Fetch('/index/int').then((r) => {
					this.banner = r.data.banner;
				});
			},
			resetGirls() {
				this.page = 1;
				this.girls = [];
				this.finished = false;
				this.empty = false;
				this.requestLock = false;
				this.loading = true;
				this.loadGirls();
			},
			loadGirls() {
				if (this.requestLock || this.finished) {
					this.loading = false;
					return;
				}
				this.requestLock = true;
				Fetch('/index/girls', {
					page: this.page
				}).then((r) => {
					var rows = r.data && r.data.list ? r.data.list : [];
					for (let i = 0; i < rows.length; i++) {
						rows[i].keys = rows[i].keystr ? rows[i].keystr.split('|') : [];
					}
					if (rows.length > 0) {
						this.girls = this.girls.concat(rows);
						this.page++;
					}
					this.empty = this.girls.length === 0;
					this.finished = !(r.data && r.data.has_more);
					this.loading = false;
					this.requestLock = false;
				}).catch(() => {
					this.loading = false;
					this.requestLock = false;
					this.finished = true;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}
	.basic_wrap {
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
	.banner-swipe {
		flex: 0 0 auto;
	}
	.head-tabs {
		flex: 0 0 auto;
	}
	.tab-content {
		flex: 1;
		overflow-y: auto;
		padding-bottom: 84px;
		-webkit-overflow-scrolling: touch;
	}
	/deep/ .van-list {
		min-height: 100%;
	}
	.pblBox{
		display: flex;
		justify-content: space-between;
		padding: 10px 20px;
		flex-wrap: wrap
	}

.releaseItem {
	width: 100%;
	margin-bottom: 15px
}

.releaseItem .imgBox {
	position: relative;
	overflow: hidden;
	border-radius: 8px;
	// height: 67vw
}

.releaseItem .imgBox>span {
	position: absolute;
	z-index: 9;
	background-color: #ebcaaf;
	color: #8d684b;
	transform: rotate(45deg);
	width: 90px;
	height: 90px;
	top: -50px;
	right: -50px;
}

.releaseItem .imgBox>span>i {
	position: absolute;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 700;
	font-size: 14px
}

.releaseItem .imgBox .infoBox {
	position: absolute;
	bottom: 0;
	left: 0;
	background: rgba(0,0,0,.4);
	display: flex;
	align-items: center;
	color: #fff;
	width: 100%;
	height: 40px;
	padding: 0 10px
}

.releaseItem .imgBox .infoBox .wantyuebtn {
	border: 1px solid #fff;
	padding: 5px 8px;
	border-radius: 8px;
	opacity: .9;
	font-size: 12px;
	margin-left: auto
}

.releaseItem .tagBox {
	font-size: 12px;
	margin: 5px 0
}

.releaseItem .di {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: #666
}
/deep/ .van-tag{
	margin: 3px;
}
/* ForeverLink-inspired ivory, gold and burgundy member directory. */
.choose_wrap,
.basic_wrap {
  min-height: 100vh;
  background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5);
  color: #533126;
}

.choose_wrap .red_top_bg {
  position: relative;
  flex: 0 0 66px;
  height: 66px;
  background: rgba(255, 252, 245, .98) !important;
  border-bottom: 1px solid rgba(190, 139, 52, .45);
  box-shadow: 0 4px 14px rgba(125, 82, 35, .08);
}

.choose_wrap .big_tit {
  position: absolute;
  top: 0;
  left: 50%;
  display: flex;
  height: 66px;
  align-items: center;
  color: #873126;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: .5px;
  transform: translateX(-50%);
}

.choose_wrap .language {
  top: 15px;
  left: auto;
  right: 13px;
  width: 36px;
  height: 36px;
  padding: 5px;
  border: 1px solid rgba(190, 139, 52, .48);
  border-radius: 50%;
  background: #fff7df;
  box-shadow: 0 3px 10px rgba(125, 82, 35, .08);
  box-sizing: border-box;
}

.choose_wrap .language img { width: 100%; height: 100%; object-fit: contain; }

.banner-swipe {
  width: calc(100% - 20px);
  
  margin: 12px auto 0;
  overflow: hidden;
  border: 1px solid rgba(190, 139, 52, .45);
  border-radius: 14px;
  background: #fffdf8;
  box-shadow: 0 9px 20px rgba(125, 82, 35, .08);
}

.banner-swipe img { display: block; width: 100%;  object-fit: cover; }
/deep/ .banner-swipe .van-swipe__indicators { bottom: 8px; }
/deep/ .banner-swipe .van-swipe__indicator { width: 7px; height: 7px; background: rgba(145, 82, 45, .3); }
/deep/ .banner-swipe .van-swipe__indicator--active { width: 18px; border-radius: 7px; background: #b9802e; }

.choose_wrap .vip-tabs {
  display: flex;
  width: calc(100% - 28px);
  min-height: 52px;
  height: 52px;
  margin: 16px 14px 2px;
  padding: 5px;
  align-items: center;
  border: 1px solid rgba(190, 139, 52, .5);
  border-radius: 14px;
  background: #fffdf8;
  box-shadow: 0 8px 18px rgba(125, 82, 35, .1);
  box-sizing: border-box;
}

.choose_wrap .vip-tabs .tab-item {
  display: flex;
  min-height: 40px;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 10px;
  color: #815c45;
  font-size: 17px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: .8px;
  box-sizing: border-box;
}

.choose_wrap .vip-tabs .tab-item.active { color: #fff8e8; background: linear-gradient(105deg, #a6233d, #ca5a5b); box-shadow: 0 4px 10px rgba(126, 28, 47, .16); }
.tab-content { padding-top: 12px; background: transparent; }
.pblBox { gap: 12px 10px; padding: 2px 10px 88px; }

.releaseItem {
  margin-bottom: 0;
  padding: 6px;
  border: 1px solid rgba(190, 139, 52, .46);
  border-radius: 13px;
  background: #fffdf8;
  box-shadow: 0 9px 20px rgba(125, 82, 35, .08);
  box-sizing: border-box;
}

.releaseItem .imgBox { height: 210px; border: 1px solid rgba(190, 139, 52, .38); border-radius: 9px; background: #fff7df; }
.releaseItem .imgBox .van-image, .releaseItem .imgBox .van-image__img { border-radius: 8px; }
.releaseItem .imgBox .van-image__img { object-fit: cover; }
.releaseItem .imgBox::after { position: absolute; inset: 0; background: linear-gradient(180deg, transparent 45%, rgba(83, 49, 38, .32)); content: ''; pointer-events: none; }
.releaseItem .imgBox > span { background: #a6233d; color: #fff8e8; }
.releaseItem .imgBox .infoBox { z-index: 2; height: 38px; padding: 0 8px; background: rgba(255, 253, 248, .86); color: #63352c; }
.releaseItem .imgBox .infoBox .wantyuebtn { border-color: rgba(166, 35, 61, .42); border-radius: 7px; background: #a6233d; color: #fff8e8; }
.releaseItem .di { min-height: 31px; padding: 6px 2px 0; color: #63352c; font-size: 12px; line-height: 24px; }
.releaseItem .di > div:first-child { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.releaseItem .di .van-icon-like { color: #a6233d !important; }
.releaseItem .di span[style] { background: #fff0ed !important; }

/deep/ .van-empty { padding-top: 56px; }
/deep/ .van-empty__description, /deep/ .van-list__finished-text, /deep/ .van-list__loading { color: #815c45; }
</style>
